export const SELECTED_DOCOTORLIST_SUCCESS = 'SELECTED_DOCOTORLIST_SUCCESS';
export const SELECTED_DOCOTORLIST_FAIL = 'SELECTED_DOCOTORLIST_FAIL';